(function () {
	'use strict';

	/**
	 * @ngdoc service
	 * @name mx.components.LazyLoadCfg
	 *
	 * @description
	 * `LazyLoadCfg` allows to set components dir, where modules/js-files that should be loaded on demand are places.
	 * This approach allows to set `componentsDir` via 'mx.components.LazyLoadCfgProvider' on config phase
	 * as well as via 'mx.components.LazyLoadCfg' on executing phase.
	 *
	 * Default dir is: 'bower_components/'.
	 *
	 * To configure components Dir make like this:
	 *
	 * For config phase:
	 * ```js
	 * .config(['mx.components.LazyLoadCfgProvider', function (lazyLoadCfgProvider) {
	 * 		lazyLoadCfgProvider.setComponentsDir('my_components_root/');
	 * 	}])
	 * ```
	 *
	 * For executing phase:
	 * ```js
	 * .run('myCtrl', ['mx.components.LazyLoadCfg', function (lazyLoadCfg) {
	 * 		lazyLoadCfg.componentsDir = 'my_components_root/';
	 * 	}]);
	 * ```
	 */
	angular.module('mx.components').provider('mx.components.LazyLoadCfg', function lazyLoadCfgProvider() {
		var _componentsDir = 'node_modules/';
		this.setComponentsDir = function (dir) {
			_componentsDir = dir;
		};
		this.$get = function () {
			return {
				componentsDir: _componentsDir,
			};
		};
	});
})();
